<app-header></app-header>
<app-famous></app-famous>
<app-chefs></app-chefs>
<app-offer></app-offer>